import React from 'react'
import { NavBrowseButton } from './NavBrowseButton'

export const NavHelpItem = ({
  title,
  bodyText,
  browseButtonProps
}: {
  title: string
  bodyText: string
  browseButtonProps: { label?: string; href?: string }
}): JSX.Element => {
  return (
    <div className="flex flex-col gap-y-8">
      <div>
        <h2 className="flex items-center pb-4 !text-xl !font-medium leading-8 !text-gray-1100">
          {title}
        </h2>
        <div className="self-stretch text-lg font-medium text-gray-700">
          {bodyText}
        </div>
      </div>

      <NavBrowseButton {...browseButtonProps} />
    </div>
  )
}
